<div class="login-form-container">
    <form *ngIf="displayMode == 'login'"
          [formGroup]="loginForm" (ngSubmit)="onSubmit()">

        <div *ngIf="errorMessage" class="iq-color-2"><strong>{{ errorMessage.title | translate }}</strong></div>
        <div *ngIf="errorMessage" class="iq-color-2 mt-1 mb-4" [innerHTML]="errorMessage.text | translate"></div>

        <div *ngIf="!accountLocked">

            <mat-form-field class="full-width">
                <mat-label>{{ 'login.label.username' | translate }}</mat-label>
                <input id="login_form.input.username"
                       type="text" matInput
                       [ngClass]="{ 'is-invalid': submitted && f.username.errors }"
                       formControlName="username"
                       autocomplete="username">
                <mat-error *ngIf="submitted && f.username.errors && f.username.errors.required">
                    {{ 'login.error.username_required' | translate }}
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>{{ 'login.label.password' | translate }}</mat-label>
                <input id="login_form.input.password"
                       type="password" matInput
                       [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
                       formControlName="password"
                       autocomplete="current-password">
                <mat-error *ngIf="submitted && f.password.errors && f.password.errors.required">
                    {{ 'login.error.password_required' | translate }}
                </mat-error>
            </mat-form-field>

            <div class="form-group mt-2">
                <button id="login_form.btn.login" mat-flat-button color="accent" class="w-100">{{ 'login.btn.login' | translate }}</button>
            </div>

            <div class="full-width" align="center">
                <a id="login_form.btn.toggle_forgot_password"
                   class="forgot-password-button iq-link-style"
                   (click)="toggleForgotPassword()">
                    {{ 'login.label.forgot_password' | translate }}
                </a>
            </div>

        </div>

    </form>

    <form *ngIf="displayMode == 'forgot_password'"
          [formGroup]="loginForm" (ngSubmit)="sendRecoveryMail()">

        <div *ngIf="!recoveryMailSent">
            <div class="iq-color-2"><strong>{{ 'login.label.forgot_password' | translate }}</strong></div>
            <div class="iq-color-2 mt-1 mb-4" [innerHTML]="'login.label.forgot_password_info' | translate"></div>

            <mat-form-field class="full-width">
                <mat-label>{{ 'login.label.username' | translate }}</mat-label>
                <input id="forgot_password_form.input.username"
                       type="text" matInput
                       [ngClass]="{ 'is-invalid': submitted && f.username.errors }"
                       formControlName="username"
                       autocomplete="username">
                <mat-error *ngIf="submitted && f.username.errors && f.username.errors.required">
                    {{ 'login.error.username_required' | translate }}
                </mat-error>
                <mat-error *ngIf="submitted && f.username.errors && f.username.errors.email">
                    {{ 'login.error.invalid_email' | translate }}
                </mat-error>
            </mat-form-field>

            <div class="form-group mt-2">
                <button id="forgot_password_form.btn.send_email" mat-flat-button color="accent" class="w-100">{{ 'login.btn.send_email' | translate }}</button>
            </div>

            <div class="full-width" align="center">
                <a id="forgot_password_form.btn.toggle_forgot_password"
                   class="forgot-password-button iq-link-style"
                   (click)="toggleForgotPassword()">
                    {{ 'login.btn.login' | translate }}
                </a>
            </div>
        </div>

        <div *ngIf="recoveryMailSent">
            <div class="iq-color-3"><strong>{{ 'login.label.forgot_password' | translate }}</strong></div>
            <div class="iq-color-3 mt-1 mb-4" [innerHTML]="'login.label.forgot_password_mail_sent' | translate"></div>
        </div>

    </form>

    <form *ngIf="displayMode == 'login_2fa'"
        [formGroup]="loginForm" (ngSubmit)="loginWith2FA()">

        <div *ngIf="errorMessage" class="iq-color-3"><strong>{{ errorMessage.title | translate }}</strong></div>
        <div *ngIf="errorMessage" class="iq-color-3 mt-1 mb-4" [innerHTML]="errorMessage.text | translate"></div>

        <div>
            <ng-container *ngIf="loginWith2FAOptions.auth_method === 'TOTP'">
                <h1 class="iq-color-3 text-center">{{ 'login.label.login_2fa.TOTP' | translate }}</h1>
                <div class="text-center"><mat-icon class="dr-icon iq-color-white icon-large">smartphone</mat-icon></div>
                <div class="iq-color-3 mt-1 mb-4" [innerHTML]="'login.label.login_2fa_app_info.TOTP' | translate"></div>
            </ng-container>
            
            <ng-container *ngIf="loginWith2FAOptions.auth_method === 'SMS'">
                <h1 class="iq-color-3 text-center">{{ 'login.label.login_2fa.SMS' | translate }}</h1>
                <div class="text-center"><mat-icon class="dr-icon iq-color-white icon-large">sms</mat-icon></div>
                <div class="iq-color-3 mt-1 mb-4" [innerHTML]="'login.label.login_2fa_app_info.SMS' | translate"></div>
            </ng-container>

            <mat-form-field class="full-width">
                <mat-label>{{ 'login.label.code' | translate }}</mat-label>
                <input id="2fa_form.input.code"
                       type="text" matInput
                       [ngClass]="{ 'is-invalid': submitted && f.code.errors }"
                       formControlName="code"
                       autocomplete="new-password"
                       autofocus>
                <mat-error *ngIf="submitted && f.code.errors && f.code.errors.required">
                    {{ 'login.error.code_required' | translate }}
                </mat-error>
            </mat-form-field>

            <div class="form-group">
                <button id="2fa_form.btn.login" mat-flat-button color="accent" class="w-100">{{ 'login.btn.login' | translate }}</button>
            </div>

            <div class="full-width" align="center">
                <div *ngIf="loginWith2FAOptions.auth_method === 'SMS'">
                    <button id="2fa_form.btn.send_new_code"
                            class="btn btn-link forgot-password-button iq-link-style"
                            type="button"
                            (click)="sendNewCode()"
                            [disabled]="newCodeTime > 0"
                    >
                        {{ 'login.label.sendNewCode' | translate }} <span *ngIf="newCodeTime > 0">{{ 'login.label.sendNewCodeTimer' | translate : {time: newCodeTime} }}</span>
                    </button>
                    <br />
                </div>
                <button id="2fa_form.btn.login_with_different_credentials"
                        class="btn btn-text forgot-password-button"
                        type="button"
                        (click)="showLoginForm()"
                >
                    {{ 'login.label.login_with_different_credentials' | translate }}
                </button>
            </div>
        </div>
    </form>
</div>
